// ============================================================================
// utils_webrtc.ts
// Constantes et utilitaires WebRTC partagés entre régie, device et mode esclave.
// ============================================================================

/**
 * Configuration ICE par défaut — partagée par :
 *   - makePeerConnection       (api_webrtcPeerConnection.ts)
 *   - makeDevicePeerConnection (api_deviceWebRTC.ts)
 *   - makeSlavePc              (api_slaveMode.ts)
 */
 /*
export const DEFAULT_ICE_SERVERS: RTCIceServer[] = [
  { urls: 'stun:stun.l.google.com:19302' },
  { urls: 'stun:stun1.l.google.com:19302' },
];
*/

export const DEFAULT_ICE_SERVERS: RTCIceServer[] = [
  { urls: 'stun:stun.l.google.com:19302' },
  { urls: 'stun:stun1.l.google.com:19302' },
  {
    urls: [
      'turn:62.210.101.187:3478?transport=udp',
      'turn:62.210.101.187:3478?transport=tcp'
    ],
    username: 'regie',
    credential: 'regieTV_2026'
  }
];

/** Raccourci pour construire une RTCConfiguration avec les serveurs ICE par défaut. */
/*export const defaultRTCConfig = (): RTCConfiguration => ({
  iceServers: DEFAULT_ICE_SERVERS,
});
*/

export const defaultRTCConfig = (): RTCConfiguration => ({
  iceServers: DEFAULT_ICE_SERVERS,
  iceTransportPolicy: 'all', // ← 'relay' force TURN, à remettre 'all' après test
  bundlePolicy: 'max-bundle',
  rtcpMuxPolicy: 'require'
});